import capaRuralFoto from '../../assets/images/capaRURAL.jpeg';

import './PlanosPremium.css';

const CapaRural = () => {
  return (
    <div className='container-fluid'>
      <div className="planos-header">
        <span className="planos-badge">Internet Rural</span>
        <h2>Tecnologia 4G LTE</h2>
      </div>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='foto-gamer'>
            <img src={capaRuralFoto} alt="foto-gamer" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default CapaRural;